import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Row,
  Alert
} from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import React, { Fragment } from "react";

import CustomDatetime from "../../elements/CustomDatetime/CustomDatetime";
import { ConfirmButton } from "../../elements/ActionButtons";
import { compose } from "recompose";

import BankAccountSelect from "../BankAccount/BankAccountSelect";
import CurrencySpan from "../Currency/CurrencySpan";
import ClientProjectSelect from "../ClientProject/ClientProjectSelect";
import { CancelButton } from "../../elements/ActionButtons/index";
import Button from "../../elements/CustomButton/CustomButton";
import Spinner from "../../elements/Spinner/Spinner";
import Checkbox from "../../elements/CustomCheckbox/CustomCheckbox.jsx";


class ProjectReaffectForm extends React.Component {
  constructor(props) {
    super(props);

    // const bankTransactionStr = props.intl.formatMessage({
    //   id: "ids_payment"
    // }) + " - " + props.tiersName;

    // // form state
    // let bankAccountsCount = 0;
    // let bankAccountSelectedCandidate = undefined;
    // let bankAccountSelected = undefined;

    // let bankAccountElements = props.bankAccounts.map(account => {
    //   if (
    //     account.dateCloture !== null &&
    //     account.dateCloture !== undefined
    //   ) {
    //     console.log("34 - closed account = ", account);
    //   } else {
    //     bankAccountsCount++;
    //     bankAccountSelectedCandidate = account.id;
    //   }
    // });

    // if (bankAccountsCount === 1){
    //   bankAccountSelected = bankAccountSelectedCandidate;
    // }

    // const bankAccountSelected = (props.bankAccounts.length === 1) ? props.bankAccounts[0].id : undefined;

    this.state = {
      ...props.values,
      projectId: props.values.projectId,
      newProjectId: null,
      newTiersClientId: (props.clientId) ? props.clientId : null,
      error: null,
      withoutProjectOrClient: false
    };
  }

  validate = () => {
    const error = (!!!this.state.withoutProjectOrClient && this.state.newProjectId === null && this.state.newTiersClientId === null);
    this.setState({ error });
    return !!!(error);
  };

  componentDidUpdate = (prevProps, prevState) => {
  };

  static getDerivedStateFromProps = async (props, state) => {
  };

  render = () => {
    const {
      intl,
      sendNotification,
      cancel,
      reaffect,
      workInProgress,
      values,
      projectName
    } = this.props;

    const locale = `${intl.locale.split("-")[0]}`;

    let { newProjectId, newTiersClientId, companyId, error } = this.state;

    let saveDisable = false;
    const disabled = false;

    // console.log("91 - this.state=", this.state);
    console.log("92 - this.props=", this.props);

    const excludedId = [];
    if (values.projectId !== null && values.projectId !== undefined)
      excludedId.push(values.projectId);

    const styleWorkInProgress = this.props.workInProgress ?
      { pointerEvents: "none", opacity: "0.4" } : {};

    return (
      <React.Fragment>

        <Row>
          <Col xs={12} sm={12}>
            <div>
              <p>
                {this.props.intl.formatMessage({
                  id: "ids_projectReaffectExplanations0"
                })}
              </p>
              <p>
                {this.props.intl.formatMessage({
                  id: "ids_projectReaffectSeveralSecondsExplanation"
                })}
              </p>
            </div>
            <hr />

            <div style={{ textAlign: "Center" }}>
              <p>
                <br />
                {this.props.intl.formatMessage({
                  id: "ids_projectReaffectExplanations1"
                })}
                &nbsp;
                <span style={{ fontSize: "140%" }}>
                  "{projectName}"
                </span>
                <br />

                {this.props.intl.formatMessage({
                  id: "ids_projectReaffectExplanationsTO"
                })}
                &nbsp;
                <br />
              </p>
            </div>

            <div style={{ textAlign: "Center" }}>
              {this.props.workInProgress ?
                <Spinner size="lg" /> :
                <i className="fa fa-5x fa-arrow-down" />
              }
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
              <br />
            </div>
          </Col>

          <Col xs={12} sm={12} mdOffset={0}
            style={
              this.state.withoutProjectOrClient ?
                { pointerEvents: "none", opacity: "0.4" } :
                {}
            }
          >
            <FormGroup
              validationState={error ? "error" : null}
              style={{ ...styleWorkInProgress }}
            >
              <ControlLabel>
                <FormattedMessage id="ids_project" />
              </ControlLabel>
              <ClientProjectSelect
                showClient={false}
                companyId={companyId}
                filter={{}}
                excludedId={excludedId}
                value={this.state.newProjectId ? this.state.newProjectId : ""}
                onSelected={e => {
                  console.log("104 - selected e=", e);
                  if (e) {
                    if (e.type === "project") {
                      this.setState({
                        newProjectId: e.value,
                        newTiersClientId: null,
                        error: null
                      });
                    }
                    else {
                      this.setState({
                        newProjectId: null,
                        newTiersClientId: e.value,
                        error: null
                      });
                    }
                  }
                  else {
                    this.setState({
                      newProjectId: null,
                      newTiersClientId: null,
                      error: null
                    });
                  }
                }}
              />
            </FormGroup>
          </Col>

          <Col xs={12} sm={12} style={{ textAlign: "Center" }}>
            <br />
            <ControlLabel style={{ display: "contents", fontSize: "300%" }}>
              <FormattedMessage id="ids_or" />
            </ControlLabel>
          </Col>

          <Col xs={12} sm={12}
            style={
              this.state.withoutProjectOrClient ?
                { pointerEvents: "none", opacity: "0.4" } :
                {}
            }
          >
            <FormGroup
              validationState={error ? "error" : null}
              style={{ ...styleWorkInProgress }}
            >
              <ControlLabel>
                <FormattedMessage id="ids_client" />
              </ControlLabel>
              <ClientProjectSelect
                showProject={false}
                companyId={companyId}
                filter={{}}
                excludedId={excludedId}
                value={this.state.newTiersClientId ? this.state.newTiersClientId : ""}
                onSelected={e => {
                  console.log("104 - selected e=", e);
                  if (e) {
                    if (e.type === "project") {
                      this.setState({
                        newProjectId: e.value,
                        newTiersClientId: null,
                        error: null
                      });
                    }
                    else {
                      this.setState({
                        newProjectId: null,
                        newTiersClientId: e.value,
                        error: null
                      });
                    }
                  }
                  else {
                    this.setState({
                      newProjectId: null,
                      newTiersClientId: null,
                      error: null
                    });
                  }
                }}
              />
            </FormGroup>
          </Col>

          <Col xs={12} sm={12} style={{ textAlign: "Center" }}>
            <br />
            <ControlLabel style={{ display: "contents", fontSize: "300%" }}>
              <FormattedMessage id="ids_or" />
            </ControlLabel>
          </Col>

          <Col xs={12} sm={12}>
            <br />
            <Checkbox
              number={1}
              isChecked={this.state.withoutProjectOrClient}
              label={intl.formatMessage({ id: "ids_withoutProjectOrClient" })}
              onCheck={value => {
                // console.log("27 - value=", value);
                this.setState(
                  { withoutProjectOrClient: value, error: null }
                );
              }}
            />
          </Col>


          <Col xs={12} sm={12}>
            <div style={{ textAlign: "Center" }}>
              <br />
              <br />
              <div>
                <Row>
                  <Col xs={12}>
                    <Alert bsStyle="warning">
                      <FormattedMessage id="ids_projectReaffectExplanations2" />
                    </Alert>
                  </Col>
                </Row>
              </div>
              {/* <p>
                {this.props.intl.formatMessage({
                  id: "ids_projectReaffectExplanations2"
                })}
              </p> */}
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={5}>
            <div className="side-modal-footer"
              style={{ ...styleWorkInProgress }}
            >
              <CancelButton
                fill
                onClick={() => {
                  console.log("CANCEL...");
                  this.props.goBack();
                }}
              />
              <Button
                icon
                bsStyle="primary"
                // disabled={this.state.newProjectId === null && this.state.newTiersClientId === null}
                onClick={event =>
                  setTimeout(() => {
                    if (this.validate()) {
                      reaffect(this.state);
                    }
                  }, 250)
                }>
                <i className="fa fa-lg fa-check" />
                <FormattedMessage id="ids_confirm" />
              </Button>

            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  };
}

export default compose(injectIntl)(ProjectReaffectForm);
